import { render } from "./loaderIndex.vue?vue&type=template&id=4035a03f&scoped=true"
const script = {}

import "./loaderIndex.vue?vue&type=style&index=0&id=4035a03f&lang=scss&scoped=true"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4035a03f"]])

export default __exports__